export default {
  open_standalone: 'Ouvert',
  closed_standalone: 'Fermé',

  open: 'Ouverts',
  closed: 'Fermés',
  opening: 'Ouvre',
  closing: 'Fermé',
  yes_we_are: 'Nous sommes',
  sorry_we_are: 'Nous sommes',
  twentyfourseven: '24h/24',
  closing_tomorrow: 'Fermé demain',
  opening_tomorrow: 'Ouvre demain',
  at_x: 'à %x%',
  closing_x: 'Fermé %x%',
  opening_x: 'Ouvre %x%',

  monday: 'lundi',
  tuesday: 'mardi',
  wednesday: 'mercredi',
  thursday: 'jeudi',
  friday: 'vendredi',
  saturday: 'samedi',
  sunday: 'dimanche',

  businessHours: "Heures d'ouverture"
};



// WEBPACK FOOTER //
// ./src/commons/translations/fr.js